import React from 'react';
import { Icon } from '../../../pages/DesignSystem';
import './ViewToggle.css';

export type ViewMode = 'list' | 'planning';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange }) => {
  return (
    <div className="view-toggle">
      <button
        className={`view-toggle__button ${value === 'list' ? 'view-toggle__button--active' : ''}`}
        onClick={() => onChange('list')}
        aria-label="List view"
        type="button"
      >
        <Icon name="List" size={18} />
      </button>
      <button
        className={`view-toggle__button ${value === 'planning' ? 'view-toggle__button--active' : ''}`}
        onClick={() => onChange('planning')}
        aria-label="Planning view"
        type="button"
      >
        <Icon name="CalendarDays" size={18} />
      </button>
    </div>
  );
};

export default React.memo(ViewToggle);
